export default "__VITE_ASSET__i3cXt70r__"